import { Grid, Heading } from '@afterpaytouch/core'
import { NextPage } from 'next'
import { useTranslation } from '../../utils/convergence'
import React, { ReactElement, useEffect } from 'react'
import { BackLink, Head, OneTimePassword } from '../../../src/component'
import { Route, usePostLoginRoute } from '../../../src/config/router'
import { TrackPageViewed } from '../../../src/integrations/monitoring'
import { markInteractiveLogin } from '../../../src/flow/remember-me/loginSignal'
import { useAppRouter, useIsOtpAsPrimaryLoginMethodEnabled } from '../../../src/state'
import { useCheckoutSizes } from '../../../src/utils/responsive'

export const LoginOneTimeCodePage: NextPage = (): ReactElement => {
  const { t } = useTranslation()
  const router = useAppRouter()
  const { headingSize } = useCheckoutSizes()
  const postLoginRoute = usePostLoginRoute()
  const isOtpAsPrimaryLoginEnabled = useIsOtpAsPrimaryLoginMethodEnabled()

  useEffect(() => {
    router.prefetch(Route.ENTER_PASSWORD)
    router.prefetch(Route.LOGGED_IN)
  }, [])

  const pageTitle = `${t('common:brandName')}` // TODO: [accessibility] fix page title to be descriptive

  return (
    <>
      <Head title={pageTitle} />
      <BackLink backTo={isOtpAsPrimaryLoginEnabled ? Route.ENTER_EMAIL : Route.ENTER_PASSWORD} />
      <Grid>
        <Heading size={headingSize}>{t('oneTimePassword:heading')}</Heading>
      </Grid>
      <OneTimePassword
        onSuccess={(locale) => {
          // Only a login that will mount LoggedIn marks the remember-me signal; a mid-flow
          // re-login routes back into the flow and must not mint.
          if (postLoginRoute === Route.LOGGED_IN) {
            markInteractiveLogin()
          }
          router.push(postLoginRoute, locale)
        }}
        onAccountLocked={() => router.push(Route.ENTER_PASSWORD)}
        onSecondaryRoute={() => router.push(Route.ENTER_PASSWORD)}
      />
      <TrackPageViewed />
    </>
  )
}
